module.exports = __webpack_public_path__ + "static/media/Taxidaicon.abe7602d.svg";